import Vue from 'vue'
import Router from 'vue-router'
import ScheduleList from '@/pages/schedule-list'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'ScheduleList',
      component: ScheduleList
    }
    // {
    //   path: '/',
    //   name: 'ScheduleList',
    //   component: ScheduleList
    // },
    // {
    //   path: '/',
    //   name: 'ScheduleList',
    //   component: ScheduleList
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js